import { Parameter } from './parameter.model';

/**
 * A class to store query parameters
 */
export class Parameters {
  /** Get accessor for hasParameters */
  public get hasParameters(): boolean {
    return this._parameters.length > 0 ? true : false;
  }

  /** An array of parameters */
  private _parameters: Parameter[] = [];

  /**
   * Add a parameter to the Parameters object
   * @param name - The name of the paramter to add
   * @param value - The value of the parameter to add
   */
  public add(name: string, value: string) {
    this._parameters.push(new Parameter(name, value));
  }

  /**
   * Get the parameter string
   * @returns A parameter string
   */
  public getParamterString(): string {
    let parameterString = '?';
    for (const parameter of this._parameters) {
      if (parameterString !== '?') {
        parameterString += '&';
      }
      parameterString += parameter.name + '=' + parameter.value;
    }
    return parameterString;
  }
}
